module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"companions\"-in-inglewood-california-daa17911e2fc4095ddfccc35c339f145.png";